/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_ACTION_GENERATOR = gql`
  query GetActionGenerator($id: ID!, $actionFilters: ActionFilter) {
    actionGenerator(id: $id) {
      id
      title
      description
      startDate
      endDate
      dueDateTime
      repeatSchedule
      actionType
      parentGenerator {
        id
        title
      }
      subGenerators {
        id
        title
        description
        dueDateTime
        actionType
        repeatSchedule
      }
      aiContextImages {
        id
        url
        type
      }
      actions(filters: $actionFilters) {
        id
        title
        description
        dueDate
        dueDateTime
        actionType
        status
        store {
          id
          location {
            id
            name
            address1
            city
            state
            postalCode
          }
        }
        notes {
          id
          note
          createdTime
          createdBy {
            id
            firstName
            lastName
            email
          }
        }
        completions {
          id
          startTime
          endTime
          images {
            id
            url
          }
          completedBy {
            id
            firstName
            lastName
            email
          }
        }
        actionGroup {
          id
          title
        }
        actionShift {
          id
          title
        }
      }
    }
  }
`
